module.exports = __webpack_public_path__ + "img/winner6.73ed0060.png";